import * as React from 'react'
import { css } from 'react-emotion'
import {
  Column,
  DotDivider,
  Icon,
  Layout,
  Row,
  Text,
  styleguide,
} from 'styleguide'
import * as Illustrations from '../../Illustrations'

export default function({ className }) {
  return (
    <Layout size="medium">
      <Row
        justify="space-between"
        align="center"
        break
        css={`
          z-index: 3;
        `}>
        <Row
          align="start"
          break
          css={`
            min-width: 50%;
          `}>
          <Icon
            icon="response-rates"
            css={`
              margin-right: 20px;
              margin-top: 3px;
              ${styleguide.mobile(css`
                margin-bottom: 20px;
              `)};
            `}
          />
          <Column justify="start">
            <Text subtitle serif bold secondary>
              Get Actionable Data
            </Text>
            <DotDivider />
            <Text subtext pt>
              Stop asking the three or four users you know personally for their
              feedback, start learning from your whole user-base.
            </Text>
            <br />
            <Text subtext pt>
              We help you ask your questions on site, in context, to maximize
              accurate response rates.
            </Text>
          </Column>
        </Row>
        <Row
          css={`
            margin-left: 40px;
            ${styleguide.mobile(
              css`
                margin-left: 0;
                margin-top: 40px;
              `
            )}
           
            background-color: ${styleguide.colors.background};
            border-radius: ${styleguide.radii.outer};
            overflow: hidden;
            position: relative;
            z-index: 4;
            background-image: url('./actionableData.gif');
            background-repeat: no-repeat;
            background-size: 100%;
            ${styleguide.shadows.button};
          `}>
          <div
            css={`
              padding-top: 62.5%;
              width: 100%;
            `}
          />
        </Row>
      </Row>
      <div
        css={`
          position: absolute;
          width: 100%;
          bottom: 196px;
          transform: scale3d(0.7, 0.7, 1) translateX(100px);
          transform-origin: top;
          ${styleguide.desktop(
            css`
              top: -218px;
              transform: none;
            `
          )};
        `}>
        <Illustrations.Stripes
          color="primary"
          css={`
            position: absolute;
            right: -200px;
            top: -80px;
            width: 800px;
            height: 800px;
            z-index: 0;
            ${styleguide.desktop(
              css`
                top: -200px;
              `
            )};
          `}
        />
        <Illustrations.ChevronCircle
          css={`
            position: absolute;
            right: 200px;
            top: 160px;
            width: 350px;
            height: 350px;
            z-index: 1;
          `}
        />
        <Illustrations.PokadotCircle
          css={`
            position: absolute;
            right: 500px;
            top: 150px;
            width: 150px;
            height: 150px;
            z-index: 0;
          `}
        />
      </div>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/GetActionableData/index.js